<ng-container *ngIf="isAgreed(field)">

    <ng-container *ngIf="field.type=='separator'">
        <div class="form-group">
            <h5 *ngIf="field.label" class="text-info">{{field.label}}</h5>
            <hr/>
        </div>
    </ng-container>
    <div class="row mb-1">
        
        <div class="col-lg-2 pr-lg-0 L{{field.show_label}}" *ngIf="(field.show_label==1 || force_label) && !noLabel">
            <!-- [class.bg-greenline]="field.value && field.value!='' && field.value!='[]' && field.value.name!=''"
            [class.bg-redline]="field.required==true && (!field.value || field.value=='' || field.value=='[]')" -->
            <!-- <label [class.text-compiled]="field.value && field.value!='' && field.value!='[]'"> -->
            <label>
                <span *ngIf="field.label==''">{{field.name}}</span>
                <span *ngIf="field.label!=''">{{field.label}}</span>
                <span *ngIf="field.required==true" class="text-gray" title="Obbligatorio">&nbsp;*</span>
            </label>
        </div>

        <div class="col-lg-10 mb-1" [class.col-lg-12]="!field.show_label || noLabel">
            
            <ng-container *ngIf="field.type=='text'">
                <div class="input-group input-group-sm">
                    <input type="text" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                    <div class="input-group-append" *ngIf="field.value && field.value.toString().startsWith('http')">
                        <a class="btn btn-primary" href="{{field.value}}" title="Apre il link in un altra scheda" target="_blank"><i class="fa fa-eye"></i></a>
                    </div>
                </div>                
            </ng-container>

            <ng-container *ngIf="field.type=='formula'">
                <div class="input-group input-group-sm">
                    <input type="number" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                    <div class="input-group-append">
                        <button class="btn btn-primary" (click)="calculateFormula(field.defaultvalue,field)" title="Calcola"><i class="fa fa-calculator"></i></button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="field.type=='number'">
                <input type="number" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value" (ngModelChange)="triggerAllFormulas()">
            </ng-container>

            <ng-container *ngIf="field.type=='currency'">
                <div *ngIf="editFieldCurrency" class="input-group input-group-sm">
                    <input #currencyInput type="number" min="0.00" step="0.01" [disabled]="disabled" class="form-control form-control-sm text-right" name="{{i}}_{{field.name}}" 
                        [(ngModel)]="field.value" (ngModelChange)="triggerAllFormulas()" (paste)="pasteCurrency($event)" (focusout)="editFieldCurrency=false">
                    <div class="input-group-append">
                        <span class="input-group-text bg-white">Euro</span>
                    </div>                
                </div>
                <span *ngIf="!editFieldCurrency" class="form-control form-control-sm text-right" (click)="editFieldCurrency=true">{{field.value | currency:'EUR'}}</span>
            </ng-container>

            <ng-container *ngIf="field.type=='textarea'">
                <textarea type="text" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value"></textarea>
            </ng-container>

            <ng-container *ngIf="field.type=='date'">
                <div class="input-group input-group-sm">
                    <input type="date" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">            
                    <div class="input-group-append" *ngIf="field.defaultvalue">
                        <button class="btn btn-primary" (click)="DateDefaultValue(field)" title="Calcola data"><i class="fa fa-calculator"></i></button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="field.type=='time'">
                <input type="time" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
            </ng-container>

            <ng-container *ngIf="field.type=='boolean'">
                <div class="btn-group btn-group-sm">                    
                    <button [class.bg-success]="field.value==1" [disabled]="disabled" type="button" class="btn btn-default border btn-sm px-4" (click)="field.value=1">
                        Sì</button>
                    <button [class.bg-secondary]="field.value==0" [disabled]="disabled" type="button" class="btn btn-default border btn-sm px-4" (click)="field.value=0">
                        No</button>
                </div>
                <!-- <select [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                </select> -->
            </ng-container>

            <ng-container *ngIf="field.type=='checkbox'">
                <input type="checkbox" [disabled]="disabled" class="form-control form-control-sm" style="width:1rem" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
            </ng-container>

            <ng-container *ngIf="field.type=='select'">
                <div class="input-group input-group-sm">               
                    <select [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                        <option value="{{o}}" *ngFor="let o of field.params">{{o}}</option>
                    </select>                
                    <div class="input-group-append" *ngIf="is_select_localdb">
                        <button class="btn btn-primary" (click)="addSelectValue(field)" title="Aggiungi"><i class="fa fa-plus"></i></button>
                    </div>
                </div>            
            </ng-container>

            <ng-container *ngIf="field.type=='file'">        
                <!-- <ng-container *ngIf="isFileMultiple(field)"> -->
                    <ul class="list-group">
                        <ng-container *ngFor="let f of parseMultipleFile(field.value)">
                            <li class="list-group-item">
                                <div class="row">
                                    <div class="col-9 pl-0">
                                        <i class="far {{getFileTypeIcon(getExtension(f))}} mr-2"></i>
                                        <small>{{getFilename(f)}}</small>
                                    </div>
                                    <div class="col-3 px-0 text-right">
                                        <button class="btn btn-info btn-sm" *ngIf="field.value" (click)="downloadFile(f)" title="Visualizza"><i class="far fa-eye"></i></button>
                                        <button *ngIf="!disabled" class="btn btn-danger btn-sm" (click)="deleteFile(field,f)" title="Rimuovi"><i class="fa fa-trash"></i></button>
                                        <button class="btn btn-success btn-sm" (click)="addFile(field)" title="Aggiungi"><i class="fa fa-plus"></i></button>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                    <ng-container *ngIf="!field.value || field.value=='' || field.value=='[]'">
                        <button *ngIf="!disabled" class="btn btn-block btn-outline-primary btn-sm" (click)="addFile(field)"><i class="fas fa-upload mr-2"></i>Carica File</button>
                    </ng-container>
                <!-- </ng-container> 

                <ng-container *ngIf="!isFileMultiple(field)">
                    <div class="input-group input-group-sm">                
                        <input type="text" [readonly]="true" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                        <div class="input-group-append">
                            <button class="btn btn-secondary btn-sm" *ngIf="!disabled" (click)="addFile()">Seleziona</button>
                            <button class="btn btn-info btn-sm" *ngIf="field.value" (click)="downloadFile(field.value)" title="Visualizza"><i class="far fa-eye"></i></button>
                        </div>
                    </div>
                </ng-container>-->
            
            </ng-container>

            <!-- 
            <ng-container *ngIf="field.type=='textarea'">
                <textarea type="text" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value"></textarea>
            </ng-container>
            <ng-container *ngIf="field.type=='date'">
                <div class="input-group">
                    <input type="date" [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                </div>
            </ng-container>
            -->

            <ng-container *ngIf="field.type=='photo'">
                <br/>
                <ng-container *ngIf="isPhotoMultiple(field)">
                    <div class="row">
                        <ng-container *ngFor="let i of parseMultiplePhoto(field.value)">
                            <div class="col-3">
                                <img class="img-thumbnail" style="max-width: 100px" src="{{pathImage(i)}}">
                                <button *ngIf="!disabled" style="position: absolute;left: 5px;top: -7px;"class="btn btn-danger btn-sm" (click)="deletePhoto(field,i)"><i class="fa fa-times"></i></button>
                            </div>
                        </ng-container>
                    </div>
                    <button *ngIf="!disabled" class="mt-2 btn btn-block btn-success" (click)="addPhoto(field)"><i class="fa fa-camera mr-2"></i>Aggiungi foto</button>
                </ng-container>

                <ng-container *ngIf="!isPhotoMultiple(field)">
                    <div class="row">
                        <div class="col-3">
                            <img *ngIf="field.value!=''" class="img-thumbnail" style="max-width: 100px" src="{{pathImage(field.value)}}" >
                            <button *ngIf="field.value!='' && !disabled" style="position: absolute;left: 5px;top: -7px;"class="btn btn-danger btn-sm" (click)="field.value=''"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                    <button *ngIf="field.value!='' && !disabled" class="mt-2 btn btn-block btn-info" (click)="takePhoto(field);"><i class="fa fa-camera mr-2"></i>Cambia foto</button>
                    <button *ngIf="field.value=='' && !disabled" class="mt-2 btn btn-block btn-success" (click)="takePhoto(field);"><i class="fa fa-camera mr-2"></i>Scatta una foto</button>
                </ng-container>       
            </ng-container>

            <ng-container *ngIf="field.type=='address'">
                <ng-container *ngIf="field.value.name && field.value.name!=''">
                    <div class="input-group input-group-sm">
                        <input type="text" disabled="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" value="{{field.value.name}}">
                        <div class="input-group-append">
                            <button class="btn btn-primary" *ngIf="!disabled" (click)="selectAddress(field)" title="Cambia anagrafica"><i class="fa fa-list"></i></button>
                            <button class="btn btn-info" *ngIf="!disabled && field.value.id" (click)="openAddress(field.value.id)" title="Visualizza anagrafica"><i class="fa fa-eye"></i></button> 
                            <button class="btn" *ngIf="!disabled && field.value.id" (click)="unlinkAddress(field)" title="Disassocia"><i class="fa fa-unlink text-danger"></i></button>            
                        </div>
                    </div>
                </ng-container>
                <button *ngIf="!field.value.name || field.value.name==''" class="btn btn-sm btn-block btn-outline-primary" (click)="selectAddress(field)"><i class="fa fa-user mr-2"></i>Scegli...</button>
            </ng-container>

            <ng-container *ngIf="field.type=='document'">
                <ng-container *ngIf="field.value.name && field.value.name!=''">
                    <div class="input-group input-group-sm">
                        <input type="text" disabled="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" value="{{field.value.name}}">
                        <div class="input-group-append">                        
                            <button class="btn btn-primary" *ngIf="!disabled" (click)="selectDocument(field)" title="Cambia documento"><i class="fa fa-list"></i></button>
                            <button class="btn btn-warning" *ngIf="!disabled" (click)="printDocument(field.value.id)" title="Stampa / Esporta"><i class="fa fa-print"></i></button>
                            <button class="btn btn-info" *ngIf="!disabled" (click)="openDocument(field.value.id)" title="Modifica / Vedi"><i class="fa fa-pencil-alt"></i></button>
                            <button class="btn" *ngIf="!disabled" (click)="field.value.id=0;field.value.name=''" title="Scollega documento"><i class="text-danger fa fa-times"></i></button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="(!field.value.name || field.value.name=='') && !disabled">
                    <button class="btn btn-sm btn-block btn-outline-success" (click)="newDocument(field)"><i class="fa fa-plus mr-2"></i>Genera documento</button>        
                    <button  class="btn btn-sm btn-block btn-outline-primary" (click)="selectDocument(field)"><i class="fa fa-list mr-2"></i>Associa documento</button>        
                </ng-container>            
            </ng-container>

            <ng-container *ngIf="field.type=='table'">
                <ng-container *ngFor="let section of field.params">
                <div class="border p-1">
                    <div *ngIf="field.value && field.value.length==0" class="p-5 mb-1 border text-center text-secondary">
                        <i class="icon fas fa-info-circle mr-2"></i>
                        <i>Tabella vuota!</i>
                    </div>
                    <ng-container *ngIf="field.value && field.value.length>0">
                        <div class="input-group mb-1">
                            <input type="text" class="form-control form-control-sm" placeholder="cerca nella tabella ..." [(ngModel)]="searchTableText" (keyup.enter)="searchTable(field.value)" >
                            <div class="input-group-append">
                                <button type="button" class="btn btn-sm btn-default text-primary" title="Cerca" (click)="searchTable(field.value)"><i class="fa fa-search"></i></button>
                                <button type="button" class="btn btn-sm btn-default text-danger ml-4" Title="Cancella tutto" (click)="emptyTable(field)"><i class="fa fa-trash mr-2"></i>Elimina Tutti</button>
                            </div>
                        </div>
                        <div class="table-responsive mb-2" style="max-height:30rem; overflow:auto">
                            <table class="table table-sm table-striped mb-0">
                                <thead>
                                    <tr>
                                        <ng-container *ngFor="let f of section.fields">                                           
                                            <th *ngIf="f.show_label==0">
                                                <span *ngIf="f.label">{{f.label}}</span>
                                                <i *ngIf="!f.label">{{f.name}}</i>
                                                <ng-container *ngIf="f.searchable">
                                                    <small *ngIf="f.type!='boolean'" class="ml-1 text-gray" title="Il valore del campo è ricercabile">*</small>                                            
                                                    <select *ngIf="f.type=='boolean'" title="filtra valori" class="form-control form-control-sm" name="filter_boolean_{{f.name}}" [(ngModel)]="filter_boolean[f.name]" (ngModelChange)="searchTable(field.value)">
                                                        <option [ngValue]="-1">Tutti</option>
                                                        <option [ngValue]="1">Si</option>
                                                        <option [ngValue]="0">No</option>                                                    
                                                    </select>
                                                </ng-container>                                        
                                            </th>
                                        </ng-container>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let v of field.value">
                                        <tr *ngIf="!v.hide" >
                                            <ng-container *ngFor="let f of v.fields">
                                                <td class="pb-0 pt-2" *ngIf="checkFieldShow(f,section.fields)">
                                                    <app-field  [field]="f" [fields]="fields" [phases]="phases"></app-field>                                                                    
                                                </td>
                                            </ng-container>
                                            <td class="text-right" style="min-width: 4.5rem">
                                                <button class="btn btn-sm btn-default text-primary" title="Modifica" (click)="openDetailTable(v,section.fields)"><i class="fa fa-pen"></i></button>
                                                <button class="btn btn-sm btn-default text-danger" title="Elimina" (click)="deleteRowTable(field.value,v)"><i class="fa fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>                        
                        </div>
                    </ng-container>
                    <button class="btn btn-sm btn-block btn-outline-success mb-1" (click)="addRowTable(field.value,section.fields)"><i class="fa fa-plus mr-1"></i>Aggiungi riga</button>
                    <button class="btn btn-sm btn-block btn-outline-primary mb-1" (click)="openImportModal(field)"><i class="fa fa-file-import mr-1"></i>Importa dati</button>            
                </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="field.type=='inventories'">
                <select [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                    <option  *ngFor="let i of inventories" [ngValue]="i.id">{{i.id}} - {{i.name}}</option>
                </select>
            </ng-container>

            <ng-container *ngIf="field.type=='cashes'">
                <select [disabled]="disabled" class="form-control form-control-sm" name="{{i}}_{{field.name}}" [(ngModel)]="field.value">
                    <option  *ngFor="let c of cashes" [ngValue]="c.id">{{c.id}} - {{c.name}}</option>
                </select>
            </ng-container>

            <ng-container *ngIf="field.description">
                <small class="text-gray"><i title="{{field.description}}" class="fas fa-info-circle mr-1"></i><i [innerHTML]="field.description"></i></small>    
            </ng-container>    
        </div>        

    </div>
</ng-container>

<ng-template #modalTableDetail>
    <div class="modal-header">
        <span><i class="fa fa-pen mr-2"></i>Dettaglio Riga</span>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeDetailTable()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body" style="max-height:70vh; overflow:auto">
        <div class="row">
            <ng-container *ngFor="let f of fields_detail.fields">
                <div class="col-lg-3" >
                    <label>
                        <span *ngIf="f.label">{{f.label}}</span>
                        <i *ngIf="!f.label">{{f.name}}</i>
                        <small *ngIf="f.searchable" class="ml-1 text-gray" title="Il valore del campo è ricercabile">*</small>
                    </label>
                </div>
                <div class="col-lg-9">
                    <app-field [field]="f" [phases]="phases"></app-field>
                </div>
            </ng-container>
        </div>
    </div>
   <div class="modal-footer">
        <button class="btn btn-outline-primary btn-block" (click)="closeDetailTable()">Ok</button>
    </div>
</ng-template>


<ng-template #modalImportTable>
    <div class="modal-header">
        <span>Importa dati in tabella</span>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeImportModal()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12 col-lg-9">
                <label>Formato dati</label>
                <select class="form-control form-control-sm mb-2" [(ngModel)]="dataFromFormat">
                    <option [ngValue]="'json'">JSON</option>
                    <option [ngValue]="'csv'">CSV</option>
                </select>
                <label>Testo da importare</label>
                <textarea class="form-control form-control-sm" (paste)="onPaste($event)" placeholder="Inserisci il testo da importare..." rows="8" [(ngModel)]="dataFromImport"></textarea>
                <ng-container *ngIf="dataFromFormat=='csv' && dataFromImport!=''">           
                    <button class="btn btn-sm btn-outline-primary float-right mt-1" (click)="parseCSV(dataFromImport)"><i class="fa fa-sync mr-2"></i>Converti testo</button>
                    <br>
                    <label>Anteprima</label>
                    <div *ngIf="!tableDataImport.length" class="p-5 text-center border alert-primary"><i>Nessun dato utile!</i></div>
                    <div class="table-responsive border bg-light" style="max-height:18rem;overflow-y:scroll">
                        <table class="table table-sm table-bordered small" *ngIf="tableDataImport.length">
                            <tr *ngFor="let row of tableDataImport">
                                <td *ngFor="let cell of row">{{cell}}</td>
                            </tr>
                        </table>
                    </div>
                </ng-container>
            </div>
            <div class="d-none d-lg-block col-lg-3 border-left">
                <i class="fa fa-info-circle fa-3x text-gray mb-2"></i><br>
                <small>
                    E' possibile importare, in tabella, dati in formato JSON o in formato CSV (per es. da Excel).<br>
                    <br>
                    I dati in formato CSV possono essere importati selezionando e copiando le celle presenti in Excel (CTRL+C) ed incollandole (CTRL+V) qui nell'apposita casella.<br>
                    <br>
                    Attenzione, le colonne che verranno inserite sono solo quelle già presenti nella tabella. Per questa tabella le colonne sono:<br>
                    <div *ngFor="let p of dataFromField.params" style="max-height:6rem;overflow-y: auto;"> 
                        <span *ngFor="let f of p.fields">- {{f.name}}<br></span>
                    </div>
                </small>
            </div>
        </div>       
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="importData()"><i class="fa fa-file-import mr-2"></i>Importa</button>
        <button type="button" class="btn btn-outline-secondary" (click)="closeImportModal()"><i class="fas fa-times mr-2"></i>Annulla <small>(ESC)</small></button>
    </div>
</ng-template>